import CatalogoCabecalho, { CatalogoNavegacao } from '../../../components/CatalogoCabecalho';
import { useCatalogoBusca } from '../../../hooks/useCatalogoBusca';
import { produtoCorrespondeBusca } from '../../../Utils/catalogoCabecalho';
import { storeCalendar } from '../../../Utils/storeTimezone';
import { cartProductAvailable, createCartAvailabilityContext } from '../../../Utils/cartAvailability';
import DeliveryClosedNotice from '../../../components/DeliveryClosedNotice';
import { useStoreWelcomeModal } from '../../../hooks/useStoreWelcomeModal';
import { useDeliveryStatus } from '../../../hooks/useDeliveryStatus';
import { getDeliveryClosedReason } from '../../../Utils/storeStatus';
// import { BleClient } from '@capacitor-community/bluetooth-le';
import { IonButton, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonModal, IonPage, IonRow, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { alertCircleOutline, cartOutline, giftOutline, logoWhatsapp, syncOutline, ticketOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../contexts/MessageContext';
import { useCartProductRequest } from '../../../hooks/useCartProductRequest';
import useAnalytics from '../../../hooks/useAnalytics';
import { useStoreSwitch } from '../../../hooks/useStoreSwitch';
import StoreAccessBoundary from '../../../components/StoreAccessBoundary';
import { cadastrarELogarDireto, requestService } from '../../../Utils/Services';
import Carrinho from '../Carrinho/Carrinho';
import Entrar from '../Entrar/Entrar';
import InformacoesEmpresa from '../InformacoesEmpresa/InformacoesEmpresa';
import OrdensProdutosCompor from '../OrdensProdutosCompor/OrdensProdutosCompor';
import "./Pedido.css";

type Props = {
  id: any;
  nome: any;
};

const Pedido: React.FC<Props> = (props: Props) => {

  // Hooks de navegação
  const history = useHistory<any>();
  const [showModalCarrinho, setShowModalCarrinho] = useState(!true);

  // Estados relacionados a loading e feedback visual
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // Estados de dados e listas
  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const { productRequest, chooseProduct } = useCartProductRequest(dadosEmpresa, setDadosEmpresa);
  const currentCartItems = useRef(listaItemProdutos);
  currentCartItems.current = listaItemProdutos;
  useDeliveryStatus();
  const analytics = useAnalytics();

  // Referências
  const contentCatalogoRef = useRef<any>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);

  const [showModalInformacoes, setShowModalInformacoes] = useState(false);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;


  // no topo do componente
  const [showHorarioInfo, setShowHorarioInfo] = useState(true);

  // ===== ESTADOS =====
  const [selectedCategoria, setSelectedCategoria] = useState<string>('');
  const coverRef = useRef<HTMLDivElement>(null);
  const busca = useCatalogoBusca(contentRef, coverRef, selectedCategoria, setSelectedCategoria, dadosEmpresa?.pk || '');
  const [isManualScrolling, setIsManualScrolling] = useState(false);

  // ===== REF =====
  const categoriasRef = useRef<HTMLDivElement>(null);

  const { welcomeModal, dismissWelcomeModal } = useStoreWelcomeModal(dadosEmpresa);

  const [showModalEntrar, setShowModalEntrar] = useState(false);
  const { canSwitchStore, requestStoreSwitch, storeSwitchAlert } = useStoreSwitch(() => {
    dismissWelcomeModal();
    setShowModalCarrinho(false);
    setSelectedCategoria('');
  });




  useEffect(() => {
    if (!selectedCategoria || !categoriasRef.current) return;

    const btn = categoriasRef.current.querySelector(
      `[data-categoria="${selectedCategoria}"]`
    ) as HTMLElement | null;

    if (btn && categoriasRef.current) {
      const container = categoriasRef.current;
      const btnRect = btn.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offset = btnRect.left - containerRect.left + container.scrollLeft;

      container.scrollTo({
        left: offset - container.clientWidth / 2 + btnRect.width / 2,
        behavior: "smooth",
      });
    }
  }, [selectedCategoria]);

  const getCategoryElement = (name: string) => Array.from(contentRef.current?.querySelectorAll<HTMLElement>('.catalogo-categoria') || [])
    .find(element => element.id === `category-${name}`);

  const scrollToCategory = async (categoryName: string) => {
    setIsManualScrolling(true);
    setSelectedCategoria(categoryName);

    const el = getCategoryElement(categoryName);
    if (!el) {
      setTimeout(() => setIsManualScrolling(false), 300);
      return;
    }

    try {
      // tenta pegar o elemento real que faz o scroll dentro do IonContent
      const scrollEl: HTMLElement | null = contentRef.current ? await contentRef.current.getScrollElement() : null;

      // altura da base do header na viewport
      const headerEl = contentRef.current?.closest('.ion-page')?.querySelector('.catalogo-sticky') as HTMLElement | null;
      const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
      const EXTRA_TOP = 6; // ajuste fino se precisar

      if (scrollEl) {
        // rects relativos à viewport
        const scrollRect = scrollEl.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        // queremos que o topo do elemento fique logo abaixo do header:
        const desiredTopInViewport = headerBottom + EXTRA_TOP;
        // diferença em px entre a posição atual do elemento e a posição desejada (na viewport)
        const deltaViewport = elRect.top - desiredTopInViewport;

        // converte para target absoluto em scrollTop do scrollEl
        const target = Math.max(0, scrollEl.scrollTop + deltaViewport);

        console.log('[SCROLL] category:', categoryName, {
          elOffsetTop: el.offsetTop,
          elRectTop: elRect.top,
          headerBottom,
          deltaViewport,
          scrollTop: scrollEl.scrollTop,
          target
        });

        // faz o scroll no container interno (mais confiável)
        scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        // fallback: usa scrollIntoView + ajusta scroll-margin-top para compensar o header
        el.style.scrollMarginTop = `${headerBottom + EXTRA_TOP}px`;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) {
      console.warn('scrollToCategory error', err);
    } finally {
      // libera o spy depois do scroll (pequeno delay)
      setTimeout(() => setIsManualScrolling(false), 400);
    }
  };

  // ===== SCROLL SPY =====
  const handleContentScroll = (e: any) => {
    const scrollTop = e?.detail?.scrollTop ?? 0;

    // Controla a visibilidade do conteúdo de horário baseado no scroll
    const threshold = coverRef.current?.offsetHeight || 0;
    setShowHorarioInfo(scrollTop < threshold);
    if (isManualScrolling || busca.restoring.current) return;

    const allCategories =
      dadosEmpresa?.categoriaProdutos?.filter((c: any) => {
        // Filtro 1: Não mostrar complementos
        if (c.tipo === "complementos") return false;

        // Filtro 2: Verificar se a categoria tem produtos disponíveis
        return shouldShowCategory(c);
      }) || [];

    const headerEl = contentRef.current?.closest('.ion-page')?.querySelector('.catalogo-sticky') as HTMLElement | null;
    const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;

    // Se ainda não temos categoria selecionada, seleciona a primeira visível
    if (!selectedCategoria && allCategories.length > 0) {
      const firstCategory = allCategories[0];
      const firstEl = getCategoryElement(firstCategory.nome);
      if (firstEl) {
        const firstRect = firstEl.getBoundingClientRect();
        if (firstRect.bottom > headerBottom) {
          setSelectedCategoria(firstCategory.nome);
          return;
        }
      }
    }

    if (selectedCategoria) {
      const currentIndex = allCategories.findIndex((cat: any) => cat.nome === selectedCategoria);

      // Verifica se alguma categoria anterior está começando a aparecer (scroll para cima)
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevCat = allCategories[i];
        const prevEl = getCategoryElement(prevCat.nome);
        if (prevEl) {
          const prevRect = prevEl.getBoundingClientRect();
          // Se a categoria anterior está aparecendo na tela
          if (prevRect.bottom > headerBottom && prevRect.top < window.innerHeight) {
            setSelectedCategoria(prevCat.nome);
            return;
          }
        }
      }

      // Verifica se a categoria atual ainda está visível
      const currentEl = getCategoryElement(selectedCategoria);
      if (currentEl) {
        const currentRect = currentEl.getBoundingClientRect();

        // Se a categoria atual ainda está visível na tela, mantém
        if (currentRect.bottom > headerBottom && currentRect.top < window.innerHeight) {
          return; // Mantém a categoria atual
        }

        // Se a categoria atual saiu completamente por cima (scroll para baixo)
        if (currentRect.bottom <= headerBottom) {
          // Procura a próxima categoria que está visível
          for (let i = currentIndex + 1; i < allCategories.length; i++) {
            const nextCat = allCategories[i];
            const nextEl = getCategoryElement(nextCat.nome);
            if (nextEl) {
              const nextRect = nextEl.getBoundingClientRect();
              // Se a próxima categoria está visível, seleciona ela
              if (nextRect.bottom > headerBottom && nextRect.top < window.innerHeight) {
                setSelectedCategoria(nextCat.nome);
                return;
              }
            }
          }
        }
      }
    }
  };

  const getHeaderOffset = () => {
    // pega o ion-header (inclui ambos toolbars) e usa a altura real
    const headerEl = contentRef.current?.closest('.ion-page')?.querySelector('.catalogo-sticky') as HTMLElement | null;
    return headerEl ? headerEl.getBoundingClientRect().height : 0;
  };

  // Funções de rolagem
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollToTop();
    }
  };

  const scrollToCatalogo = () => {
    if (contentCatalogoRef.current) {
      contentCatalogoRef.current.scrollIntoView();
    }
  };

  useIonViewDidEnter(() => {

    scrollToTop();

    // const urlParams = new URLSearchParams(window.location.search);
    // const empresaid = urlParams.get('empresaid'); // Obtém o valor do parâmetro 'convite'
    // console.log("empresaid:", empresaid);

    // console.log("entrou no useIonViewDidEnter");
    // if (empresaid) {
    //   scrollToTop();
    //   // carregarEmpresa(empresaid);
    // }
  });

  useEffect(() => {
    console.log("entrou useEffect");
    carregarSomasItemProdutos();
  }, [listaItemProdutos]);

  function carregarSomasItemProdutos() {

    // Calcula a nova soma dos valores após a remoção
    const totalValor = listaItemProdutos.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  async function adicionarItem(produto: any, avancarCarrinho: boolean = false) {

    if (!produto) return false;

    if (produto) {

      const updatedList = [...(currentCartItems.current || []), produto];
      currentCartItems.current = updatedList;

      setListaItemProdutos(updatedList);


      let totalValor = updatedList.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

      setTextToast("Item adicionado com sucesso.");
      setShowToast(true);

    }

    if (avancarCarrinho) {
      setShowModalCarrinho(true);
    }

    return true;
  }

  async function closeModalInformacoes() {
    setShowModalInformacoes(false);
  }

  async function closeModalCarrinho(pedidoId?: string) {
    await fazerLoginAutomatico('', '', { pedidoEnviado: true, pedidoId });
    setShowModalCarrinho(false);
  }

  async function closeModalCarrinhoVoltar() {
    setShowModalCarrinho(false);
  }

  async function closeModalEntrarSimple() {
    setShowModalEntrar(false);
  }

  async function closeModalEntrar(nome?: string, telefone?: string) {
    if (nome && telefone) {
      localStorage.setItem("nome", nome);
      localStorage.setItem("telefone", telefone);
    }
    setShowModalEntrar(false);
    await fazerLoginAutomatico(nome, telefone);
  }

  async function fazerLoginAutomatico(nome: string = "", telefone: string = "", checkout?: { pedidoEnviado: boolean; pedidoId?: string }) {
    const nomeFinal = (nome || localStorage.getItem("nome") || "").trim();
    const telefoneFinal = (telefone || localStorage.getItem("telefone") || "").trim();

    if (!nomeFinal || !telefoneFinal) {
      setTextToast("Erro ao fazer login. Dados incompletos.");
      setShowToast(true);
      return;
    }

    if (!checkout) setShowLoading(true);

    try {
      const body = {
        nome: nomeFinal,
        telefone: telefoneFinal,
      };

      const response = await fetch(cadastrarELogarDireto.url, {
        method: cadastrarELogarDireto.method,
        headers: {
          'Content-Type': 'application/json'
        } as HeadersInit,
        credentials: 'include',
        body: JSON.stringify(body)
      });

      const retorno = await response.json();

      if (response.status === 200 || response.status === 201) {
        console.log("Login automático realizado com sucesso:", retorno);

        // Armazena o token se retornar
        if (retorno.token) {
          localStorage.setItem("token", "token=" + retorno.token);
        }

        // Redireciona para a página Inicio
        history.replace("/cliente/ordens", checkout);
      } else {
        history.replace("/novo-login", checkout);
      }
    } catch (error) {
      history.replace("/novo-login", checkout);
    } finally {
      setShowLoading(false);
    }
  }

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  // certifique-se que contentRef existe:
  // const contentRef = useRef<HTMLIonContentElement | null>(null);

  // ✅ Função para verificar se uma categoria deve ser exibida
  const contextoDisponibilidade = createCartAvailabilityContext({ company: dadosEmpresa });

  const shouldShowCategory = (categoria: any) => {
    if (!dadosEmpresa?.catalogoProdutos) return false;

    // Encontrar produtos desta categoria
    const produtosDaCategoria = dadosEmpresa.catalogoProdutos.filter((produto: any) =>
      produto.categoria === categoria.nome && produtoCorrespondeBusca(produto, busca.query)
    );

    // Verificar se tem pelo menos um produto disponível
    const produtosDisponiveis = produtosDaCategoria.filter((produto: any) => cartProductAvailable(produto, { context: contextoDisponibilidade }));

    return produtosDisponiveis.length > 0;
  };

  // ===== COMPONENTE DE NAVEGAÇÃO DE CATEGORIAS =====
  const renderCategoriaButtons = () => {
    if (dadosEmpresa && dadosEmpresa.categoriaProdutos) {

      return (
        <div className="pedido-categorias-shell" style={{ width: '100%', display: 'flex', padding: '0px 10px', flexDirection: 'column', backgroundColor: 'white', color: 'var(--pedido-text-secondary)' }}>
          {/* Categories row */}
          <div className="pedido-categorias-scroll" ref={categoriasRef} style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', width: '100%' }}>
            {dadosEmpresa.categoriaProdutos.filter((value: any) => {
              // Filtro 1: Não mostrar complementos
              if (value.tipo === "complementos") return false;

              // Filtro 2: Verificar se a categoria tem produtos disponíveis
              return shouldShowCategory(value);
            }).map((item: any, index: any) => (
              <IonCol size="auto" key={index} style={{
                flex: '0 0 auto',
                textAlign: 'center',
                padding: '12px 16px',
                minHeight: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
                data-categoria={item.nome} // 👈 importante para localizar depois
                onClick={() => { scrollToCategory(item.nome) }}>

                <IonLabel style={{
                  fontSize: '14px',
                  color: selectedCategoria == item.nome ? 'var(--ion-color-primary)' : 'var(--pedido-text-secondary)',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  // backgroundColor: selectedCategoria == item.nome ? '#fff5f5' : 'transparent',
                  // transition: 'all 0.2s ease'
                }}>
                  {item.nomeCategoria || item.nome}
                </IonLabel>
              </IonCol>
            ))}
          </div>

        </div>
      );
    }
  };

  return (
    <StoreAccessBoundary><IonPage className="pedido-page">
      <IonHeader className="ion-no-border catalogo-sticky" hidden={!dadosEmpresa || dadosEmpresa?.bloquearAcesso || (showHorarioInfo && !busca.open)}>
        <CatalogoNavegacao open={busca.open} value={busca.query} inputRef={busca.inputRef}
          onOpen={busca.start} onChange={busca.setQuery} onClose={busca.close}>
          {renderCategoriaButtons()}
        </CatalogoNavegacao>
      </IonHeader>

      <IonContent
        ref={contentRef}
        fullscreen={true}          // opcional, ajuda o IonContent ocupar a área
        scrollEvents={true}       // muito importante
        onIonScroll={(e) => handleContentScroll(e)}
      >

        <div ref={coverRef}>{dadosEmpresa && <CatalogoCabecalho empresa={dadosEmpresa} onSearch={busca.start}
          onProfile={() => setShowModalEntrar(true)} onInfo={() => setShowModalInformacoes(true)}
          onSwitchStore={canSwitchStore ? requestStoreSwitch : undefined} />}</div>
        <IonGrid style={{ height: '100%', padding: "0px", margin: "0px" }} ref={contentCatalogoRef}>
          <IonRow style={{ height: '100%' }}>
            <IonCol style={{ height: '100%', padding: "0px", margin: "0px" }} size="12">
              {dadosEmpresa?.bloquearAcesso ? (
                <div style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  padding: '40px 20px',
                  backgroundColor: '#fff'
                }}>
                  <div style={{
                    maxWidth: '400px',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    {/* Ícone de alerta */}
                    <div style={{
                      width: '64px',
                      height: '64px',
                      margin: '0 auto 20px',
                      backgroundColor: '#ffe5e5',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <IonIcon
                        icon={alertCircleOutline}
                        color="danger"
                        style={{
                          fontSize: '40px',
                        }}
                      />
                    </div>

                    {/* Título */}
                    <h2 style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: 'var(--pedido-text-primary)',
                      marginBottom: '12px',
                      lineHeight: '1.3'
                    }}>
                      Pedidos temporariamente indisponíveis
                    </h2>

                    {/* Mensagem */}
                    <p style={{
                      fontSize: '15px',
                      color: 'var(--pedido-text-secondary)',
                      lineHeight: '1.6',
                      marginBottom: '24px'
                    }}>
                      No momento, os pedidos online estão pausados para este estabelecimento.
                      Para continuar seu atendimento, fale diretamente com a loja pelo WhatsApp.
                    </p>

                    {/* Botão de WhatsApp */}
                    {dadosEmpresa?.empresaTelefone && (
                      <IonButton
                        expand="block"
                        color="success"
                        style={{
                          '--border-radius': '8px',
                          height: '48px',
                          fontWeight: '600',
                          fontSize: '15px'
                        }}
                        onClick={() => {
                          const numero = dadosEmpresa.empresaTelefone.replace(/\D/g, '');
                          try { analytics.trackLead('whatsapp', { origem: 'pedido' }); } catch (e) { /* noop */ }
                          window.open(`https://wa.me/${numero}`, '_blank');
                        }}
                      >
                        <IonIcon icon={logoWhatsapp} slot="start" />
                        Falar no WhatsApp
                      </IonButton>
                    )}
                  </div>
                </div>
              ) : (
                <div className="pedido-catalogo-content" style={{ height: '100%' /* REMOVIDO overflow: 'auto' */ }}>
                  <OrdensProdutosCompor
                    empresa={dadosEmpresa}
                    busca={busca.query}
                    disabled={false}
                    adicionarItem={adicionarItem}
                    productRequest={productRequest}
                    {...({ selectedCategoria, onCategoriaChange: setSelectedCategoria } as any)}
                  />
                </div>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonModal className="catalogo-informacoes-modal" isOpen={showModalInformacoes} onDidDismiss={() => { setShowModalInformacoes(false); }}>
          <InformacoesEmpresa closeAction={closeModalInformacoes}></InformacoesEmpresa>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalCarrinho} onDidDismiss={() => { setShowModalCarrinho(false); }}>
          <Carrinho adicionarItem={adicionarItem} onChooseProduct={chooseProduct} logado={false} closeAction={closeModalCarrinho} closeActionVoltar={closeModalCarrinhoVoltar}></Carrinho>
        </IonModal>

        <IonModal
          isOpen={welcomeModal !== null}
          backdropDismiss={true}
          className="modal-promocional"
          onDidDismiss={dismissWelcomeModal}
        >
          {dadosEmpresa?.deliveryFechado === true ? (
            <DeliveryClosedNotice reason={getDeliveryClosedReason(dadosEmpresa)} onDismiss={dismissWelcomeModal} />
          ) : (
            <div className="modal-promocional-container">


              <div className="modal-image-section">
                <header className="modal-impact-header">
                  <IonIcon icon={giftOutline} style={{ fontSize: '44px', marginBottom: '10px' }} />
                  <h2 className="modal-impact-title">
                    VOCÊ GANHOU!
                  </h2>
                  <p className="modal-impact-subtitle">Economize agora no seu pedido</p>
                </header>

                <div className="modal-promo-content">
                  {dadosEmpresa?.cashbackAtivado && (
                    <div className="promo-item-impact">
                      <div className="promo-item-icon-box">
                        <IonIcon icon={syncOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                      </div>
                      <div className="promo-item-info">
                        <h4>CASHBACK</h4>
                        <p>{dadosEmpresa.percentualCashback || 0}% de volta</p>
                      </div>
                    </div>
                  )}

                  {(() => {
                    // Promo modal: ignora cupons invisíveis (visivel === false).
                    const cuponsVisiveis = Array.isArray(dadosEmpresa?.configuracoesCupom)
                      ? dadosEmpresa.configuracoesCupom.filter((c: any) => c?.visivel !== false)
                      : [];
                    if (cuponsVisiveis.length === 0) return null;
                    return cuponsVisiveis.length > 1 ? (
                      <div className="promo-item-impact">
                        <div className="promo-item-icon-box">
                          <IonIcon icon={ticketOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                        </div>
                        <div className="promo-item-info">
                          <h4>CUPONS DISPONÍVEIS</h4>
                          <p>Selecione no carrinho</p>
                        </div>
                      </div>
                    ) : (
                      <div className="promo-item-impact">
                        <div className="promo-item-icon-box">
                          <IonIcon icon={ticketOutline} style={{ fontSize: '24px', color: 'var(--ion-color-primary)' }} />
                        </div>
                        <div className="promo-item-info">
                          <h4>Cupom Disponível</h4>
                          <p>
                            {(() => {
                              try {
                                const cupom = cuponsVisiveis[0];
                                if ((cupom.tipoDesconto || 'fixo') === 'percentual') {
                                  const pct = parseFloat(String(cupom.valor ?? '0').replace(/\,/g, '.')) || 0;
                                  return `${pct}% OFF no pedido`;
                                }
                                const vStr = (cupom.valor ?? '0').toString();
                                const vNum = parseFloat(vStr.replace(/\./g, '').replace(/\,/g, '.')) || 0;
                                return `R$ ${vNum.toLocaleString('pt-br', { minimumFractionDigits: 2 })} OFF no pedido`;
                              } catch (e) { return 'R$ 0,00 OFF no pedido'; }
                            })()}
                          </p>
                        </div>
                      </div>
                    );
                  })()}
                </div>

                <footer className="modal-footer-impact">
                  <button
                    className="modal-impact-cta"
                    onClick={() => {
                      dismissWelcomeModal();
                    }}
                  >
                    Continuar
                  </button>
                </footer>
              </div>
            </div>
          )}
        </IonModal>

        <IonModal
          className="mini-modal catalogo-identificacao-modal"
          isOpen={showModalEntrar}
          onDidDismiss={() => { setShowModalEntrar(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <Entrar nome={localStorage.getItem("nome") || ""} celular={localStorage.getItem("telefone") || ""} logado={false} closeActionSimple={closeModalEntrarSimple} closeAction={closeModalEntrar}></Entrar>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        {storeSwitchAlert}
      </IonContent>

      {!(listaItemProdutos?.length === 0 || dadosEmpresa?.bloquearAcesso) && (
        <div className="pedido-sacola-float">
          <IonButton
            className="pedido-sacola-button"
            expand="block"
            color="primary"
            onClick={async () => {
              const agora = storeCalendar(dadosEmpresa);
              const diaAtual = agora.dayOfWeek; // 0 a 6 no fuso da loja
              const horarioAtual = agora.hour * 60 + agora.minute; // em minutos

              const diasSemanaNumber: any = {
                SUNDAY: 0,
                MONDAY: 1,
                TUESDAY: 2,
                WEDNESDAY: 3,
                THURSDAY: 4,
                FRIDAY: 5,
                SATURDAY: 6,
              };

              const diaAtualTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAtual
              );
              const diaAmanha = (diaAtual + 1) % 7;
              const amanhaTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAmanha
              );

              if (dadosEmpresa.horarios) {
                const horariosHoje = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === diaAtualTexto
                ) || [];

                const horariosAmanha = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === amanhaTexto
                ) || [];

                let estaDentroDoHorario = false;
                let proximoHorarioHoje: any = null;

                for (const horario of horariosHoje.sort((a: any, b: any) => a.start.localeCompare(b.start))) {
                  const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
                  const inicio = horaInicio * 60 + minutoInicio;
                  const fim = inicio + horario.duration;

                  if (horarioAtual >= inicio && horarioAtual <= fim) {
                    estaDentroDoHorario = true;
                    break;
                  }

                  if (horarioAtual < inicio && !proximoHorarioHoje) {
                    proximoHorarioHoje = horario;
                  }
                }

                const valorTotalProdutosNumerico = parseFloat(
                  valorTotalProdutos?.replace(/\./g, "").replace(/\,/g, ".")
                );
                const pedidoMinimoNumerico = parseFloat(
                  dadosEmpresa.pedidoMinimo?.replace(/\./g, "").replace(/\,/g, ".")
                );

                if (listaItemProdutos?.length === 0) {
                  setTextToast("Selecione pelo menos um produto.");
                  setShowToast(true);
                  // } else if (valorTotalProdutosNumerico < pedidoMinimoNumerico) {
                  //   setTextToast(
                  //     "Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos."
                  //   );
                  //   setShowToast(true);
                } else if (dadosEmpresa.agendamento) {
                  setShowModalCarrinho(true);
                } else if (!estaDentroDoHorario) {
                  if (proximoHorarioHoje) {
                    setTextToast(
                      `Não é possível realizar o pedido agora. Abrimos hoje às ${formatarHorario(
                        proximoHorarioHoje.start
                      )}.`
                    );
                  } else if (horariosAmanha.length > 0) {
                    const proximoHorarioAmanha = horariosAmanha.sort((a: any, b: any) =>
                      a.start.localeCompare(b.start)
                    )[0];
                    setTextToast(
                      `Estamos fechados. Abrimos amanhã às ${formatarHorario(
                        proximoHorarioAmanha.start
                      )}.`
                    );
                  } else {
                    setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                  }
                  setShowToast(true);
                } else {
                  setShowModalCarrinho(true);
                }
              } else {
                setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                setShowToast(true);
              }
           }}
            type="submit"
          >
            <span className="pedido-sacola-left">
              <IonIcon icon={cartOutline} />
              <span>Ver Carrinho</span>
            </span>
            <span className="pedido-sacola-total">
              {valorTotalProdutos ? `R$ ${valorTotalProdutos}` : "R$ 0,00"}
            </span>
          </IonButton>
        </div>
      )}
    </IonPage></StoreAccessBoundary>
  );


};

export default Pedido;
